import React, { ForwardedRef, forwardRef } from 'react';

import ModalDialog from './ModalDialog';
import { ModalDialogProps } from './ModalDialogTypes';

const Modal = forwardRef(({ children, ...rest }: ModalDialogProps, ref?: ForwardedRef<HTMLDivElement>) => {
    return (
        <ModalDialog {...rest} ref={ref}>
            {children}
        </ModalDialog>
    );
});

export default Modal;
